<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      class="b"
      d="M6.27 18.32H2.1A1.09 1.09 0 011 17.24v-.66a6.46 6.46 0 01.54-2.69 5.09 5.09 0 012.75-2.72.5.5 0 00.31-.47.53.53 0 00-.17-.38 3.1 3.1 0 01-.85-2.88 3.02 3.02 0 012.45-2.38 3.1 3.1 0 013.13 1.27A5.67 5.67 0 019.7 7.5a3.03 3.03 0 00-.84 1.55 3.36 3.36 0 00.06 1.58 2.85 2.85 0 00.8 1.3.53.53 0 01.16.38.5.5 0 01-.3.47A5.09 5.09 0 006.8 15.5a6.47 6.47 0 00-.54 2.69v.13z"
    />
    <path
      class="b"
      d="M14.27 12.79a.5.5 0 01-.3-.46.51.51 0 01.15-.37l.09-.09a3.11 3.11 0 00-2.85-5.19 3.04 3.04 0 00-2.45 2.38 3.11 3.11 0 00.86 2.88.53.53 0 01.17.38.5.5 0 01-.3.46 5.12 5.12 0 00-2.75 2.73 6.51 6.51 0 00-.55 2.68v.67a1.08 1.08 0 001.09 1.08h9.05a1.08 1.08 0 001.09-1.08v-.67a6.5 6.5 0 00-.54-2.68 5.12 5.12 0 00-2.76-2.73z"
    />
    <path
      class="b"
      d="M17.57 18.32h4.19a1.09 1.09 0 001.08-1.08v-.66a6.46 6.46 0 00-.54-2.69 5.09 5.09 0 00-2.75-2.72.5.5 0 01-.3-.47.53.53 0 01.16-.37 3.1 3.1 0 00.86-2.9 3.02 3.02 0 00-2.46-2.37 3.1 3.1 0 00-3.13 1.27 5.67 5.67 0 00-.53 1.18A3.03 3.03 0 0115 9.06a3.36 3.36 0 01-.07 1.58 2.85 2.85 0 01-.8 1.3.53.53 0 00-.16.38.5.5 0 00.3.47 5.09 5.09 0 012.76 2.73 6.47 6.47 0 01.54 2.68v.13z"
    />
  </g>
</template>
<style scoped>
.b{fill:none;stroke:currentColor;stroke-width:1.7px}
</style>